import React from 'react';
import busicon from '../../../../../resources/images/bus_lokalizacja/busicon.png'
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";

export default class PokazNaMapieLokalizacje extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: {lat: 50.04, lng: 22},
            zoom: 8,
            mapTypeId: 'roadmap',
            lat: null,
            lng: null
        };
        this.getMap = this.getMap.bind(this)
    }

    componentDidMount() {
        let map = this.getMap();
        if (Boolean(this.props.lokalizacje)) {
            this.zaznaczBusyNaMapie(this.props.lokalizacje, map)
        }
    }

    componentWillReceiveProps(nextprops){
        if (Boolean(nextprops.lokalizacje)) {
            let mapa = this.getMap(nextprops.lokalizacje[0].latlng)
            this.zaznaczBusyNaMapie(this.props.lokalizacje, mapa)
        }
    }

    getMap(center = this.state.center) {

        let map = new window.google.maps.Map(document.getElementById('map'), {
            center: this.state.center,
            zoom: this.state.zoom,
            mapTypeId: this.state.mapTypeId,
        });

        map.addListener('zoom_changed', () => {
            this.setState({
                zoom: map.getZoom()
            });
        });

        map.addListener('maptypeid_changed', () => {
            this.setState({
                mapTypeId: map.getMapTypeId(),
            });
        });

        return map
    }

    setMarker(wspolrzedne, mapa = this.getMap(), obj) {

        let infowindow = new window.google.maps.InfoWindow({
            content: '<div>' +
                '<div><span class="label label-ebus-default">'+obj.nazTr+'</span> Kurs: '+obj.idKu+'</div>' +
                '<div style="margin-top: 5px"><span>Rozpoczęcie kursu: '+obj.data+' </span><span>'+DateAndTimeFormat.formatHHMM(obj.godz_1p)+'</span></div>'+
                '<div style="margin:5px 0"><i class="fa fa-user"></i> '+obj.nazKi+', <i class="fa fa-phone"></i> '+obj.nrTel+'</div>' +
                '<div><i class="fa fa-bus"></i> '+obj.nazPo+', '+ obj.nrRej+'</div>' +
                '</div>',
            maxWidth: 400
        })

        let marker = new window.google.maps.Marker({
            map: mapa,
            position: wspolrzedne,
            icon: busicon,
            label:{
                text:obj.nrRej+'',
                fontWeight:'bold',
                fontSize:'12px',

            },
        })

        marker.addListener('click',function () {
           // this.onClickMarker(obj)
            infowindow.open(mapa, marker);
        }.bind(this))
    }

    onClickMarker(obj){
        console.log(obj)
    }

    setCenter(wspolrzedne) {
        this.setState({center: wspolrzedne})
        this.getMap(wspolrzedne).setCenter(wspolrzedne)
    }

    zaznaczBusyNaMapie(busy, mapa) {
        let bounds = new window.google.maps.LatLngBounds();

        var latlngDifference = 0.01;

        for (let i = 0; i < busy.length; i++) {
            this.setMarker(busy[i].latlng, mapa, busy[i])

            console.log(busy[i].latlng)

            bounds.extend(busy[i].latlng)
        }

        console.log(bounds)

        if(busy.length>1){
            mapa.fitBounds(bounds);
        }else{
            // tylko jeden bus - nalezy oddalić


            mapa.fitBounds({
                east: (busy[0].latlng.lng + latlngDifference),
                west: (busy[0].latlng.lng - latlngDifference),
                north: (busy[0].latlng.lat + latlngDifference),
                south: (busy[0].latlng.lat - latlngDifference),
            })

        }



    }

    render() {
        return (
            <div>
                <div style={{clear: 'both'}}>
                    <div id='map' style={{height: '75vh'}}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/lokalizacjaBusow/googleMapComponents/PokazNaMapieLokalizacje.js